import Vue from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/vant'
import './plugins/elementUI'
import './styles/base.scss'
import '@/assets/icons/iconfont.css'
import AsyncComputed from 'vue-async-computed'

Vue.use(AsyncComputed)
// import wpkReporter from 'wpk-reporter' // 导入基础sdk
// const __wpk = new wpkReporter({
//   bid: 'hfgtuobp-ucwkzemu', // 新建应用时确定
//   plugins: []
// })
// if (process.env.NODE_ENV == 'production') {
//   __wpk.installAll()
// }
import VueLazyComponent from '@xunlei/vue-lazy-component'

Vue.use(VueLazyComponent)
// // 初始化sdk 必须调用
Vue.config.productionTip = false

if (process.env.VUE_APP_ENABLE_VCONSOLE === 'true') {
  new VConsole()
  console.log('VConsole is running')
}
let pathnameList = document.location.pathname.split(`/`)
import YunLinked from 'yunlinked'
//import YunLinked from '../../linked-js/src/index.js'
Vue.use(YunLinked, {
  dsn: process.env.VUE_APP_YunLinked_URL,
  apikey: 'ICard',
  skeletonProject: true,
  silentPerformance: true,
  env: process.env.VUE_APP_YunLinked_ENV,
  useImgUpload: true,
  silentError: true,
  maxBreadcrumbs: 3,
  ext_config: JSON.stringify({
    module: pathnameList[pathnameList.length - 1],
  }),
  linkedIds: [
    {
      index: 'nameInput',
      type: 'id',
      env: 'oninput',
      name: '姓名触达',
    },
    {
      index: 'phoneNumberInput',
      type: 'id',
      env: 'oninput',
      name: '手机号触达',
    },
    {
      index: 'idcardInput',
      type: 'id',
      env: 'oninput',
      name: '身份证触达',
    },
    {
      index: 'detailedAddressInput',
      type: 'id',
      env: 'oninput',
      name: '详细地址触达',
    },
    {
      index: 'phoneNumberSearchInput',
      type: 'id',
      env: 'oninput',
      name: '号码搜索触达',
    },

    {
      index: 'phoneNumberSelectclick',
      type: 'id',
      env: 'onclick',
      name: '号码选择触达',
      immediatelyUp: true,
    },
    {
      index: 'formExpandclick',
      type: 'id',
      env: 'onclick',
      name: '展开按钮触达',
      immediatelyUp: true,
    },

    {
      index: 'submitclick',
      type: 'id',
      env: 'onclick',
      name: '下单按钮点击触达',
    },
    {
      index: 'agreeclick',
      type: 'id',
      env: 'onclick',
      name: '表单协议点触达',
    },
    {
      index: 'phoneNumberSearchAllclick',
      type: 'id',
      env: 'onclick',
    },
    {
      index: 'phoneNumberSearchAAA+click',
      type: 'id',
      env: 'onclick',
    },
    {
      index: 'phoneNumberSearchAABBclick',
      type: 'id',
      env: 'onclick',
    },

    {
      index: 'phoneNumberSearchABABclick',
      type: 'id',
      env: 'onclick',
    },
    {
      index: 'phoneNumberSearchLOVEclick',
      type: 'id',
      env: 'onclick',
    },
    {
      index: 'phoneNumberSearchABCDclick',
      type: 'id',
      env: 'onclick',
    },
    {
      index: 'phoneNumberSearchAAAclick',
      type: 'id',
      env: 'onclick',
    },
    {
      index: 'phoneNumberSearch88click',
      type: 'id',
      env: 'onclick',
    },
    {
      index: 'jumptoTiktok',
      type: 'id',
      env: 'onclick',
      name: '点击跳转抖音号',
      immediatelyUp: true,
    },
  ],
})

new Vue({
  beforeCreate() {
    Vue.prototype.$bus = this
  },
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
